<div class="tabs-container">
	<div class="flex gap-2 border-b border-gray-200 bg-white">
		<ng-container *ngFor="let tab of tabs">
			<div
				class="py-4 border-b-2 duration-300 -mb-[1px] bg-white"
				[ngClass]="{
					'border-green': isActive(tab),
					'border-transparent': !isActive(tab),
				}"
			>
				<button
					class="px-3 py-1 rounded-md hover:bg-gray-200 duration-300 flex items-center gap-x-2"
					(click)="selectTab(tab)"
					type="button"
					[testHook]="testHooks.SelectTabButton"
				>
					<ng-container *ngTemplateOutlet="tab.preTitleTemplate"></ng-container>
					<span class="h5">
						{{ tab.title }}
					</span>
					<ng-container
						*ngTemplateOutlet="tab.postTitleTemplate"
					></ng-container>
				</button>
			</div>
		</ng-container>
	</div>
	<div class="py-6">
		<ng-container *ngIf="activeTab?.template">
			<ng-container *ngTemplateOutlet="activeTab.template"></ng-container>
		</ng-container>
	</div>
</div>
